import React, { useEffect } from "react";
import { createPortal } from "react-dom";
import { X } from "lucide-react";

const TailwindModal = ({ isOpen, toggle, children, maxWidth = "md" }) => {
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "unset";
    }
    return () => {
      document.body.style.overflow = "unset";
    };
  }, [isOpen]);

  if (!isOpen) return null;

  const maxWidthClasses = {
    sm: "max-w-sm",
    md: "max-w-md",
    lg: "max-w-lg",
    xl: "max-w-xl",
    "2xl": "max-w-2xl",
    "3xl": "max-w-3xl",
    "4xl": "max-w-4xl",
    "5xl": "max-w-5xl",
    "6xl": "max-w-6xl",
    "7xl": "max-w-7xl",
  };
  const predefinedWidth = maxWidthClasses[maxWidth];
  return createPortal(
    <div className="fixed inset-0 z-[9999] flex items-center justify-center overflow-x-hidden overflow-y-auto outline-none focus:outline-none">
      {/* Overlay */}
      <div
        className="fixed inset-0 bg-slate-900 bg-opacity-50 transition-opacity backdrop-blur-sm"
        onClick={toggle}
      ></div>

      {/* Modal Content */}
      <div
        className={`relative w-full ${predefinedWidth || ""} mx-auto my-auto p-3 sm:p-4 z-[10000]`}
        style={!predefinedWidth ? { maxWidth } : {}}
      >
        <div className="relative flex flex-col w-full max-h-[calc(100vh-2rem)] bg-white border-0 rounded-xl shadow-2xl outline-none focus:outline-none overflow-hidden">
          {children}
        </div>
      </div>
    </div>,
    document.body,
  );
};

export const TailwindModalBody = ({ children, className = "" }) => (
  <div className={`relative p-4 sm:p-5 flex-auto overflow-y-auto ${className}`}>{children}</div>
);

export const TailwindModalHeader = ({ toggle, title, subtitle, icon, className = "" }) => (
  <div className={`flex items-center justify-between p-3.5 sm:px-4 sm:py-3 border-b border-slate-200 border-solid rounded-t ${className}`}>
    <div className="flex items-center gap-2.5 min-w-0">
      {icon && (
        <div className="p-2 bg-blue-50 text-blue-600 rounded-lg border border-blue-100 shadow-sm shrink-0">
          {icon}
        </div>
      )}
      <div className="min-w-0">
        <h3 className="text-base font-bold text-slate-800 leading-tight">{title}</h3>
        {subtitle && <p className="text-xs text-slate-500 mt-0.5 font-normal">{subtitle}</p>}
      </div>
    </div>
    {toggle && (
      <button
        className="p-1 ml-auto bg-transparent border-0 text-slate-400 hover:text-slate-600 float-right outline-none focus:outline-none transition-colors -mr-1 shrink-0"
        onClick={toggle}
      >
        <X size={18} />
      </button>
    )}
  </div>
);

export const TailwindModalFooter = ({ children }) => (
  <div className="flex items-center justify-end p-4 sm:px-5 sm:py-4 border-t border-slate-200 border-solid rounded-b">
    {children}
  </div>
);

export default TailwindModal;
